// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseScheduledTable_root__r3Lmh","rows":"CoursePauseScheduledTable_rows__0BSvk","pagination":"CoursePauseScheduledTable_pagination__gXogQ"};